import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from "recompose";

import { withStyles } from '@material-ui/core/styles';

import EnhancedTable from './EnhancedTable';
import ImportPipedrive from './ImportPipedrive';
import FormComponent from './FormComponent';
import { userActions, clientActions, projectActions, departmentActions } from '../../_actions';

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: {
        margin: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        [theme.breakpoints.down('sm')]: {
            height: '90%',
            width: '80%',
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        width: '90%',
        margin: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit,
    },
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            importPipedriveOpen: false,
            projectData: null,
        };
    }

    componentDidMount() {
        this.props.dispatch(userActions.getAll());
        this.props.dispatch(clientActions.getAll());
        this.props.dispatch(projectActions.getAllByUserId(this.props.user.id, true));
        this.props.dispatch(departmentActions.getAll());
    }

    handleOpen = () => {
        this.setState({
            open: true,
            projectData: null
        });
    };

    handleClose = () => {
        this.cleanData();
    };

    handleImportPipedriveOpen = () => {
        this.setState({
            importPipedriveOpen: true,
        });
    };

    handleImportPipedriveClose = () => {
        this.setState({
            importPipedriveOpen: false,
        });
    };

    handleEditTable = (EditData) => {
        this.setState({
            open: true,
            projectData: EditData
        });
    }

    handleDeleteTable = (DeleteData) => {
        this.props.dispatch(projectActions.delete(DeleteData));
    }

    cleanData() {
        this.setState({
            open: false,
            projectData: null,
        });
    }

    render() {
        return (
            <div>
                <EnhancedTable
                    handleOpen={this.handleOpen}
                    handleImportPipedriveOpen={this.handleImportPipedriveOpen}
                    handleEditTable={this.handleEditTable}
                    handleDeleteTable={this.handleDeleteTable}
                    departmentId={this.props.user.departmentId}
                />

                <ImportPipedrive
                    open={this.state.importPipedriveOpen}
                    close={this.handleImportPipedriveClose}
                />

                <FormComponent
                    open={this.state.open}
                    close={this.handleClose}
                    projectData={this.state.projectData}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;

    return {
        user
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(App);



// WEBPACK FOOTER //
// ./src/components/Projects/App.js